import {
  Autocomplete,
  Button,
  ButtonGroup,
  Stack,
  TextField,
} from '@mui/material'
import { Add } from '@mui/icons-material'
import { tsStudy } from '../../../Typescript/StuartPy/Study'
import * as React from 'react'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { useGlobalContext } from '../../../Contexts/GlobalTriggers'
import { useCreateStudy } from '../../../APIs/Hooks/StudyHooks'
import { useNavigate, useParams } from 'react-router-dom'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { useUserContext } from '../../../Contexts/UserConfig'

export function StudySelectToolbar({
  studyListQuery,
  protocol_id,
  statusFilter,
  setStatusFilter,
}: {
  studyListQuery: UseQueryResult<tsStudy[], AxiosResponse<any, any>>
  protocol_id: string
  statusFilter: string
  setStatusFilter: any
}) {
  const navigate = useNavigate()
  const { study_id } = useParams()
  const { setLoadingDialog } = useGlobalContext()
  const { loginConfig } = useUserContext()
  const { mutate: addStudy } = useCreateStudy(protocol_id, {
    onSuccess: (data: tsStudy) => {
      setLoadingDialog(false)
      navigate(`/stuart/study/${data.StudyID}/configure`)
    },
  })
  return (
    <Stack
      aria-label={'StudySelectToolbar'}
      direction={'row'}
      gap={stackGap.row}
      width={1}
      sx={{ mb: 2 }}
    >
      <Button
        variant={'outlined'}
        sx={{ minWidth: 160 }}
        onClick={() => {
          setLoadingDialog(true)
          addStudy()
        }}
        startIcon={<Add />}
        disabled={
          !protocol_id || !loginConfig?.Modules?.EditStudy || study_id === '1'
        }
      >
        New Study
      </Button>
      <Autocomplete
        fullWidth
        autoHighlight
        onChange={(event: any, newValue: any) =>
          navigate(`${newValue?.value}/configure`)
        }
        options={
          studyListQuery?.data ?
            studyListQuery.data.map((item) => {
              return {
                value: item.StudyID,
                label: `${item.StudyID} - ${item.StudyName}`,
              }
            })
          : []
        }
        renderInput={(params: any) => (
          <TextField
            {...params}
            fullWidth
            placeholder="Search in list below..."
          />
        )}
      />
      <ButtonGroup sx={{ display: 'flex' }}>
        <Button
          variant={statusFilter === 'PEN' ? 'contained' : undefined}
          disabled={statusFilter === 'PEN'}
          onClick={() => setStatusFilter('PEN')}
        >
          Pending
        </Button>
        <Button
          variant={statusFilter === 'ACT' ? 'contained' : undefined}
          disabled={statusFilter === 'ACT'}
          onClick={() => setStatusFilter('ACT')}
        >
          Active
        </Button>
        <Button
          variant={statusFilter === 'ARC' ? 'contained' : undefined}
          disabled={statusFilter === 'ARC'}
          onClick={() => setStatusFilter('ARC')}
        >
          Archived
        </Button>
      </ButtonGroup>
    </Stack>
  )
}
